/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OpenExamRequest } from './openExamRequest';

export type OpenMcqExamBody = OpenExamRequest | null;
